import {createDataStore} from './createDataStore';

// Caches /data/llmData.json for the LLM tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
export const useLlmDataStore = createDataStore(
    '/data/llmData.json',
    'llm-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses']
);
